import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "vue"

export type RetrieveCustomerResponse = {
  id: string
  name: string
  email: string
  phone: string
  description: string
  totalPayments: number
  createdByUser?: string
}

export const retrieveCustomer = async (
  customerId: string
): Promise<RetrieveCustomerResponse> => {
  const { body } = await api.get<RetrieveCustomerResponse>(
    `/services/customers/${customerId}/`
  )

  return body
}

export const useCustomer = (customerId: MaybeRef<string>) =>
  useQuery({
    queryKey: [CUSTOMERS_QUERY_KEY, customerId] as const,
    queryFn: ({ queryKey: [_, customerId_] }) =>
      retrieveCustomer(customerId_),
  })
